<aside class="w-full h-full bg-primary-950 overflow-y-auto ">
    <ul class="capitalize text-xl">
        <li><button onclick="history.back()" class="btn w-full h-16 flex items-center justify-start text-3xl bg-transparent hover:bg-white/10 text-white/50 hover:text-white border-0 rounded-none"><i class="ri-arrow-left-long-line"></i></button></li>
        @for(i of menus;track $index){
            @if(i.items.length > 0){
                <li>
                    <div class="collapse bg-transparent hover:bg-white/10 text-white/50 hover:text-white border-0 rounded-none ">
                        <input type="checkbox" id="sidebar-{{i.label}}"/>
                        <div class="collapse-title w-full flex items-center justify-between">{{i.label}} <i class="ri-arrow-down-s-line"></i></div>
                        <div class="collapse-content p-0">
                            
                            <ul class="flex flex-col">
                                @for(j of i.items;track j.label){   
                                    <li><a [routerLink]="['/'+j.url]" routerLinkActive="router-link-active" class="text-sm  px-5 py-3 hover:bg-white/20 text-white  flex w-full">{{j.label}}</a></li>
                                }
                            </ul>
                        </div>
                      </div>
                </li>
            }@else{
                <li>
                    <a [routerLink]="['/'+i.url]" routerLinkActive="router-link-active"  class="w-full flex px-5 py-3 hover:bg-white/10 text-white/50 hover:text-white border-0 rounded-none" >{{i.label}}</a>
                </li>
            }
        }
    
    
    </ul>



</aside>    